<template>
  <div class="cont-main">
    <div class="flex flex-y-center flex-x-between m-b-10">
      <div class="flex flex-y-center">
        <span>协同状态：</span>
        <el-radio-group v-model="detailData.formData.xie_tong_status_str">
          <el-radio v-for="(item, index) in xieTongStatusList" :key="index" :label="item">
            {{ item }}
          </el-radio>
        </el-radio-group>
      </div>
      <div>
        <el-popover placement="top-start" title=" " width="240" trigger="hover">
          <el-link slot="reference" class="el-icon-time">
            <span class="m-l-2">修改记录</span>
          </el-link>
          <div v-if="detailData.formData.last_update_json.length" class="el-popover-content">
            <el-timeline reverse>
              <el-timeline-item
                v-for="(item, index) in detailData.formData.last_update_json"
                :key="index"
                :timestamp="item.date"
                type="primary"
              >
                {{ item.name }}
              </el-timeline-item>
            </el-timeline>
          </div>
          <div v-else>无</div>
        </el-popover>
      </div>
    </div>
    <div class="box-y-scroll" :style="{ 'max-height': maxHeight }">
      <div class="table-main">
        <el-link
          v-if="id"
          class="link-total-detail"
          type="warning"
          @click="openPopupVerifyGoodsDetail"
        >
          制造明细
        </el-link>
        <TableSale
          v-if="loaded"
          tableTitle="bom表清单"
          :parent="null"
          :data.sync="detailData.tableSaleData"
        />
      </div>
    </div>

    <div class="flex flex-y-center flex-x-between">
      <div class="m-t-10"></div>
      <div class="total-main">
        <span v-for="(item, index) in formColumn3" :key="index" class="total-item">
          <span>{{ item.title }}:</span>
          <span class="total-item-price">{{ detailData.formData[item.field] || 0 }}</span>
          <span>{{ item.suffix }}</span>
        </span>
      </div>
    </div>

    <div class="flex flex-y-center flex-x-end b-t-1 p-t-10">
      <el-button type="primary" size="mini" @click="detailSave(true)"> 保存 </el-button>
    </div>

    <!-- 弹窗-制造明细 -->
    <b-popup-verify-goods-detail
      v-if="isShowPopupVerifyGoodsDetail"
      :show.sync="isShowPopupVerifyGoodsDetail"
      :id="id"
      :isVerify="false"
    />
  </div>
</template>

<script>
import math from '@/views/new/verify/common/popup-verify-do/cont-verify/math'
export default {
  components: {
    TableSale: () => import('./table-sale')
  },
  props: {
    id: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      loaded: false,
      customerKeyword: '',
      formConfig: {
        width: '200px'
      },
      formColumn3: [
        {
          title: '产品种类',
          field: 'cost_analysis_class',
          suffix: '种'
        },
        {
          title: '需求数量',
          field: 'cost_analysis_count',
          suffix: ''
        },
        {
          title: '原材料成本',
          field: 'cost_analysis_material',
          suffix: '元'
        },
        {
          title: '加工成本',
          field: 'cost_analysis_process',
          suffix: '元'
        },
        {
          title: '其他成本',
          field: 'cost_analysis_other',
          suffix: '元'
        },
        {
          title: '成本总金额',
          field: 'cost_analysis_total',
          suffix: '元'
        }
      ],

      detailData: {
        formData: {
          version: 2,
          bill_date: '', // 销售日期
          bill_code: '', // 销售单号
          saler_id: '', // 业务员id
          saler_name: '', // 业务员
          commission_rate: '', // 提成比例
          company_name: '', // 客户
          company_id: '', // 客户id
          company_uuid: '', // 客户uuid
          saler_company_name: '', // 开单公司
          bill_remark: '', // 单据备注
          ding_dan_lei_xing: '', // 订单类型
          jiao_huo_ri_qi: '', // 交货日期
          bill_tax_rate: '', // 税率
          tax_fees_total: '', // 税金
          cost_price_total: '', // 订单成本
          sales_amount_total: '', // 订单销售金额
          profit_total: '', // 订单利润
          profit_rate_total: '', // 订单利润率
          push_money: '', // 提成金额
          xie_tong_status_str: '', // 协同状态
          last_update_json: [] // 修改记录
        },
        tableSaleData: [],
        pact_bill: {}
      }, // 详情数据
      detailTimer: null, // 详情数据更新计时器

      isShowPopupVerifyGoodsDetail: false, // 制造明细
      xieTongStatusList: ['待受理', '受理中', '已完结']
    }
  },
  computed: {
    maxHeight() {
      let result = `${this.$util.getViewHeight() - 350}px`
      return result
    }
  },
  watch: {
    'detailData.tableSaleData': {
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
            if (this.detailTimer) {
              clearTimeout(this.detailTimer)
            }
            this.detailTimer = setTimeout(() => {
              math.totalDetailData(this.detailData) // 计算-汇总详情
              this.detailTimer = null
            }, 100)
          }
        })
      },
      deep: true
    }
  },
  mounted() {
    this.loaded = false
    if (this.id) {
      this.getDetailData()
    }
  },
  methods: {
    // 获取-详情数据
    getDetailData() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/pmc/detail',
        params: {
          id: this.id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.detailData = this.$util.deepCopy(res.data)
          this.loaded = true
        }
      })
    },
    // 详情更新has_bom
    detailUpdateHasBom(list) {
      list.forEach((item) => {
        let has_bom = !!item.tableBomData.length
        item.has_bom = has_bom
        item.table_data_1[0].has_bom = has_bom
        if (has_bom) {
          this.detailUpdateHasBom(item.tableBomData)
        }
      })
    },
    // 详情-保存
    detailSave(isPrompt) {
      let data = this.$util.deepCopy(this.detailData)
      this.detailUpdateHasBom(data.tableSaleData)
      this.$api({
        method: 'post',
        url: '/admin/gcvip/pmc/saveOrUpdate',
        data
      }).then((res) => {
        if (res.data.state === 'ok') {
          if (isPrompt) this.$message.success('操作成功')
        }
      })
    },
    // 制造明细
    openPopupVerifyGoodsDetail() {
      this.isShowPopupVerifyGoodsDetail = true
    }
  }
}
</script>

<style lang="less" scoped>
.cont-main {
  display: flex;
  flex-direction: column;
  .table-main {
    position: relative;
    border: 1px solid #e8eaec;
    .link-total-detail {
      position: absolute;
      top: 8px;
      left: 85px;
      font-size: 14px;
      font-weight: bold;
      z-index: 99;
    }
    .total-item {
      & ~ .total-item {
        margin-left: 10px;
      }
      .total-item-price {
        padding: 0 5px;
        font-weight: bold;
        font-size: 14px;
        color: @colorRed;
      }
    }
  }

  .total-main {
    height: 48px;
    line-height: 48px;
    font-size: 12px;
    color: #606266;
    .total-item {
      margin-left: 20px;
      .total-item-price {
        padding: 0 5px;
        font-weight: bold;
        font-size: 14px;
        color: @colorRed;
      }
    }
  }
}
</style>
